import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { FileInput } from '@mantine/core';
const FormFileInput = forwardRef(({ className = '', ...props }, ref) => (
	<FileInput ref={ref} className={`q-form-file-input ${className}`.trim()} {...props} />
));

FormFileInput.displayName = 'FormFileInput';
FormFileInput.propTypes = {
	className: PropTypes.string,
};

export default FormFileInput;
